export const PLATFORM_INITIALIZATION_TIMEOUT_MS = 10_000;

export const withPlatformInitializationTimeout = <T>(
  operation: Promise<T>,
  timeoutMs = PLATFORM_INITIALIZATION_TIMEOUT_MS,
): Promise<T> =>
  new Promise<T>((resolve, reject) => {
    const timeout = globalThis.setTimeout(
      () => reject(new Error('PLATFORM_INITIALIZATION_TIMEOUT')),
      timeoutMs,
    );
    void operation.then(
      (value) => {
        globalThis.clearTimeout(timeout);
        resolve(value);
      },
      (error: unknown) => {
        globalThis.clearTimeout(timeout);
        reject(error instanceof Error ? error : new Error('PLATFORM_INITIALIZATION_ERROR'));
      },
    );
  });
